<template>
  <div>
    <h-msg-box v-model="setPassword" title="支付密码管理" height="240" :closable="false" :mask-closable="false" @on-close="handleCancle"
      style="text-align: left" class="h-topbar-msgbox">
      <h-form ref="setPassForm" :model="setPassForm" cols="1" :label-width="116">
        <h-form-item v-if="setPassForm.req && type != 'forgetPayPwd'" prop="oldPassword" :label="$t('m.i.common.curPwd')"
          :labelTitle="$t('m.i.common.curPwd')" :required="setPassForm.req">
          <h-input type="password" v-model="setPassForm.oldPassword" :placeholder="$t('m.i.common.enterCurPwd')"></h-input>
        </h-form-item>
        <h-form-item v-if="setPassForm.pwType === 'payPwd'" :validRules="validNewPassCheck" prop="newPayPassword"
          :label="$t('m.i.common.newPwd')" :labelTitle="$t('m.i.common.newPwd')" required>
          <h-input type="password" v-model="setPassForm.newPayPassword" placeholder="支付密码">
          </h-input>
        </h-form-item>
        <h-form-item v-if="setPassForm.pwType === 'payPwd'" :validRules="validNewPassCheck" prop="newPayPasswordCheck"
          :label="$t('m.i.common.newPwdConf')" :labelTitle="$t('m.i.common.newPwdConf')" required>
          <h-input type="password" v-model="setPassForm.newPayPasswordCheck" placeholder="确认密码">
          </h-input>
        </h-form-item>
        <h-form-item v-show="isSms || type=='forgetPayPwd'" prop="smsCode" label="短信验证码" :required="isSms">
          <h-input @on-focus="handlefocus('smsCode')" @on-blur="handleblur('smsCode')" class="sms_code" type="text"
            v-model="setPassForm.smsCode">
            <a slot="append" @click="sendSmsCode">{{sendCode}}{{unit}}</a>
          </h-input>
          <div class="verify-tip verify-bottom" v-show="smsCodeError">
            <div class="verify-tip-arrow"></div>
            <div class="verify-tip-inner">{{codeError}}</div>
          </div>
        </h-form-item>
      </h-form>
      <div slot="footer" style="margin-top: 20px">
        <a style="float:left;" v-if="type=='editPwd' && setPassForm.req" @click="forgetPayPwd">忘记支付密码</a>
        <a style="float:left;" v-if="type=='forgetPayPwd' && setPassForm.req" @click="editPayPwd">修改支付密码</a>
        <h-button v-if="closable" @click="handleCancle">{{
          $t("m.i.common.cancle")
        }}</h-button>
        <h-button type="primary" @click="handleSetPassword">{{
          $t("m.i.common.confirm")
        }}</h-button>
      </div>
    </h-msg-box>
  </div>
</template>
<script>

import { encrypt, fTime, pwdPassVlitor, payPwdPassVlitor } from '@frame/utils/Utils'
import { getAuthority, sendPhoneCode } from '@uc/api/safeCenter/index'
import { getPublicKey, getExtSysConfig } from '@frame/api/common/index'
export default {
  name: 'EditPayPassword',
  data () {
    return {
      type: 'editPwd',
      setPassword: false,
      setPassForm: {
        req: true,
        pwType: 'payPwd',
        oldPassword: '',
        newPassword: '',
        newPasswordCheck: '',
        newPayPassword: '',
        newPayPasswordCheck: '',
        smsCode: ''
      },
      validNewPassCheck: [{ test: pwdPassVlitor, trigger: 'blur' }],
      smsCodeError: false,
      codeError: '不能为空',
      closable: true,
      isEditMode: '',
      sendCode: '获取验证码',
      initExprTime: 60,
      unit: '',
      publicKey: ''
    }
  },
  watch: {
    setPassword (val) {
      if (val) {
        this.getRsaPublickKey()
      }else{
        this.getIsUserPayPasswordHadSet()
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.editPayPwd()
      // 获取协议阅读时间
      getExtSysConfig({ 'code': 'edit_pwd_mode' }).then(r => {
        if (r.data.success) {
          this.isEditMode = r.data.value
          this.isSms = this.isEditMode === '2' || this.isEditMode === '3'
        }
      }).catch(e => {
        console.log(e)
      })
      let payPass = this.$getCurrInfo()['payPass']
      if (payPass === 'true') {
        this.setPassForm.req = true
      } else {
        this.setPassForm.req = false
      }
    },
    forgetPayPwd () {
      this.type = 'forgetPayPwd'
      this.sendCode = '获取验证码'
    },
    editPayPwd () {
      this.type = 'editPwd'
      this.sendCode = '获取验证码'
    },
    // 获取公钥
    getRsaPublickKey () {
      getPublicKey({}).then(r => {
        if (r.data.success) {
          this.publicKey = r.data.publicKey
        }
      }).catch(e => {
        console.log(e)
      })
    },
    handleCancle () {
      this.$refs['setPassForm'].resetFields()
      this.setPassword = false
      this.init()
    },
    sendSmsCode () {
      if (this.sendCode !== '获取验证码') {
        return
      }
      let params = {
        type: this.type
      }
      if (this.type == 'forgetPayPwd') {
        params['cell_phone'] = this.$getCurrInfo()['cellPhone']
      }
      sendPhoneCode(params).then((r) => {
        if (r.data.success) {
          this.$hMessage.success('发送成功')
          this.sendCode = this.initExprTime
          this.unit = '(s)'
          // 获取失效时间
          let time = setInterval(() => {
            if (this.sendCode !== '获取验证码') {
              this.sendCode--
            }
            if (this.sendCode <= 0 || this.sendCode === '' || this.sendCode === '获取验证码') {
              clearInterval(time)
              this.sendCode = '获取验证码'
              this.unit = ''
            }
          }, 1000)
        } else {
          this.$hMessage.error(r.data.errorInfo)
        }
      }).catch((e) => {
        console.error(e)
      })
    },
    /**
     * 确认修改密码
    **/
    handleSetPassword () {
      this.$refs['setPassForm'].validate((valid) => {
        if (valid) {
          let opt = ''
          let msg = ''
          if (this.setPassForm.req && this.type != 'forgetPayPwd') {
            opt = '1'
            msg = '修改成功'
          } else {
            opt = '4'
            msg = '设置成功'
          }
          let userId = this.$getCurrInfo()['userId']
          let oldCode = ''
          let newCode = ''
          let reNewCode = ''
          if (this.setPassForm.pwType === 'payPwd') {
            if (this.setPassForm.req) {
              if (
                this.setPassForm.oldPassword === this.setPassForm.newPayPassword
              ) {
                this.$hMessage.error('原密码与新密码不能一致')
                return
              }
              oldCode = encrypt(this.setPassForm.oldPassword, this.publicKey)
            }
            newCode = encrypt(this.setPassForm.newPayPassword, this.publicKey)
            reNewCode = encrypt(
              this.setPassForm.newPayPasswordCheck,
              this.publicKey
            )
          }
          if (this.isSms && this.setPassForm.smsCode === '') {
            this.smsCodeError = true
            return
          }
          let params = {
            userId: userId,
            opt: opt,
            type: this.setPassForm.pwType,
            smsType: this.type,
            smsCode: this.setPassForm.smsCode,
            oldCode: oldCode,
            newCode: newCode,
            reNewCode: reNewCode,
          }
          this.editPwdApi(params)
        }
      })
    },
    /**
     * 调用修改密码接口
     **/
    editPwdApi (params) {
      this.$http.post(window.LOCAL_CONFIG.UC_GSV + '/ws/user/edit_pwd', params).then((res) => {
        if (res && res.data.success) {
          this.setPassword = false
          this.sendCode = 0
          this.setPassForm.smsCode = ''
          this.$hMessage.success('操作成功!')
          this.updateCurrInfo()
          this.handleCancle()
        } else {
          this.$hMessage.error(res.data.errorInfo)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    updateCurrInfo () {
      let currInfo = this.$getCurrInfo()
      currInfo['payPass'] = 'true'
      this.$setCurrInfo(currInfo)
    },
    handlefocus (param) {
      this.smsCodeError = false
    },
    handleblur (param) {
      this.smsCodeError = false
    },
    getIsUserPayPasswordHadSet () {
      this.$emit('onPageAction', 'getIsUserPayPasswordHadSet')
    },
  },
}
</script>